module.exports = __webpack_public_path__ + "static/img/homeleft3.077e273.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homeleft3.png
// module id = WeNB
// module chunks = 13